import { useEffect, useState } from "react";
import ChallanForm from "./pages/ChallanForm";
import Login from "./pages/Login";
import ResetPasswordModal from "./components/ResetPasswordModal";
import SearchVehicle from "./pages/SearchVehicle";
import TableParser from "./pages/TableParser";
import Toast from "./components/Toast";
import "./components/Toast.css";
import "./App.css";

function App() {
  const [token, setToken] = useState(() => localStorage.getItem("token") || "");
  const [resetOpen, setResetOpen] = useState(false);
  const [page, setPage] = useState("search"); // search | upload | parser
  const [toasts, setToasts] = useState([]);

  const addToast = (message, type = "success") => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, type }]);
  };

  const removeToast = (id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  };

  useEffect(() => {
    const t = localStorage.getItem("token") || "";
    const expiry = localStorage.getItem("tokenExpiry");
    if (t && expiry && Date.now() > Number(expiry)) {
      localStorage.removeItem("token");
      localStorage.removeItem("tokenExpiry");
      setToken("");
    } else {
      setToken(t);
    }
  }, []);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("tokenExpiry");
    setToken("");
  };

  // Check token expiry every minute (auto logout after 24h)
  useEffect(() => {
    const checkExpiry = () => {
      const t = localStorage.getItem("token");
      const expiry = localStorage.getItem("tokenExpiry");
      if (t && expiry && Date.now() > Number(expiry)) {
        localStorage.removeItem("token");
        localStorage.removeItem("tokenExpiry");
        setToken("");
      }
    };
    checkExpiry();
    const interval = setInterval(checkExpiry, 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      {token ? (
        <div>
          <div className="app-topbar">
            <div className="app-topbar-left">
              <div className="app-topbar-brand">Digital Dekho Automation</div>
              <button
                type="button"
                onClick={() => setPage("search")}
                className={`app-topbar-btn ${page === "search" ? "app-topbar-btn-active" : ""}`}
              >
                Search
              </button>
              <button
                type="button"
                onClick={() => setPage("upload")}
                className={`app-topbar-btn ${page === "upload" ? "app-topbar-btn-active" : ""}`}
              >
                AI Parser
              </button>
              <button
                type="button"
                onClick={() => setPage("parser")}
                className={`app-topbar-btn ${page === "parser" ? "app-topbar-btn-active" : ""}`}
              >
                Manual Parser
              </button>
            </div>
            <div className="app-topbar-right">
              <button
                onClick={() => setResetOpen(true)}
                className="app-topbar-btn"
              >
                Reset Password
              </button>
              <button onClick={logout} className="app-topbar-btn app-topbar-btn-logout">
                Logout
              </button>
            </div>
          </div>
          {page === "search" ? (
            <SearchVehicle onGoUpload={() => setPage("upload")} notify={addToast} />
          ) : page === "upload" ? (
            <ChallanForm notify={addToast} />
          ) : (
            <TableParser />
          )}
          <ResetPasswordModal open={resetOpen} onClose={() => setResetOpen(false)} notify={addToast} />
        </div>
      ) : (
        <Login onAuth={(t) => setToken(t)} notify={addToast} />
      )}

      <div className="toast-fixed-wrapper">
        {toasts.map((t) => (
          <Toast
            key={t.id}
            message={t.message}
            type={t.type}
            onClose={() => removeToast(t.id)}
          />
        ))}
      </div>
    </div>
  );
}

export default App;

